// extracted by mini-css-extract-plugin
export var sharing = "styles-module--sharing--d7038";
export var widgets = "styles-module--widgets--4fd36";